<style lang="less" scoped>
  .main{
    padding-top: 45px;
    padding-bottom: 50px;
  }
  .nav {
    background-color: #000;
   height: 45px;
   border-bottom: 1px solid #eee;
    overflow: hidden;
    color: #fff;
    position: relative;
    text-align: center;
    line-height: 45px;
    font-size: 14px;
    position: fixed;
    width: 100%;
    top: 0;
  .ivu-icon{
    margin-top: 12px;
    margin-left: 10px;
    float: left;
  }
  }
  .bottom-bar{
    background: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
   border-top: 1px solid #eee;
  .bar-left{
    width: 100px;
    float: left;
    position: relative;
    text-align: center;
    padding-top: 3px;
  }
  .bar-left::before{
    content: '';
    position: absolute;
    height: 50px;
    width: 1px;
    background: #eee;
    right: 0;
    top: 0;
  }
  .bar-right{
    margin-left: 100px;
    line-height: 50px;
      text-align: center;
    .right-left{
      float: left;
      width: 50%;
    }
    .right-right{
      float: left;
      width: 50%;
      color: #fff;
      background: #ff6615;
    }
  }
  }
 .zdf{
   width: 90%;
   margin: auto;
   margin-top: 30px;
   .zdf-title{
     font-size: 20px;
     color: #ff6615;
     font-weight: 700;
     margin-bottom: 20px;
   }
   .ts-list{
     overflow: hidden;
      .ts-li{
        width: 50%;
        float: left;
        .ts{
          display: block;
          float: left;
          margin-bottom: 15px;
          border: 1px solid #f5f5f5;
          padding: 5px;
          .ts-img{
            width: 300px;
            height: 250px;
            background-color: #eee;
            background-repeat: no-repeat;
            background-size: cover;
            border: none;
          }
          .ts-title{
            height: 35px;
            line-height: 35px;
            font-size: 16px;
            color: #333;
            font-weight: 700;
          }
        }
        .hover{
         border: 1px solid #ff6615;
         background: #fff;
      }
      }
      
   }
 }
</style>

<template>
  <div class="main">
    <Spin size="large" fix v-if="load"></Spin>
    <div class="nav">
        <Icon size="24" @click="$router.go(-1)" color="#fff" type="ios-arrow-back" />
        <span>为本定制</span>
    </div>
    <div class="zdf">
      <div class="zdf-title">装订方式</div>
      <div class="ts-list">
          <div class="ts-li" v-for="(item,index) in rdata.list" :key="index">
            <div class="ts" :class="{'hover':index==tindex}" @click="tindex=index">
                <div class="ts-img" :style="{'background-image':'url('+item.picture+')'}"></div>
                 <div class="ts-title">{{item.product_name}}</div>
            </div>
          </div>
      </div>
    </div>


<div class="bottom-bar">
  <div class="bar-left" @click="$router.push({ path: '/'})">
    <Icon type="ios-home" size="25" />
    <div>首页</div>
  </div>
  <div class="bar-right">
    <div class="right-left" @click="$router.go(-1)">
      上一步
    </div>
    <div class="right-right" @click="goDiy">
      下一步
    </div>

  </div>
</div>
  </div>
</template>

<script>
  var that;
  import Store from 'store';
  import {POST} from "../plugins/core";
  export default {
    name: 'product',
    data() {
      return {
        load: true,
        tindex:0,
        rdata:{
          list:[]
        }
      }
    },
    mounted() {
      that = this;
      that.init();
    },
    methods: {
      goDiy(){
        var id=that.rdata.list[that.tindex].id;
        that.$router.push({ path: '/diy/'+id})

      },
      init(){
          POST('/getAdviserProduct', {}).then(function(res) {
          that.load = false;
          if (res.state == 200) {
            that.rdata = res.data;
          }
        });
      }
    }
  }
</script>
